import { CancellablePromise } from '@lifaon/observables';
import { HTTP_ROUTE_PRIVATE } from './privates';
import { ConstructHTTPRoute } from './constructor';
import { Route } from '../../core/route/implementation';
import { $super } from '../../misc/instance/snippets';
export function CreateHTTPRouteResolver() {
    return function (options) {
        const instance = this;
        const privates = instance[HTTP_ROUTE_PRIVATE];
        const normalizedOptions = options;
        return CancellablePromise.try(() => {
            return (privates.methods === null)
                || privates.methods.has(normalizedOptions.method);
        }, normalizedOptions)
            .then((resolved) => {
            return resolved
                && privates.resolve.call(instance, normalizedOptions);
        });
    };
}
const HTTP_ROUTE_RESOLVER = CreateHTTPRouteResolver();
export function HTTPRouteGetMethods(instance) {
    return instance[HTTP_ROUTE_PRIVATE].methods;
}
export class HTTPRoute extends Route {
    constructor(path, options = {}) {
        const _options = {
            ...options,
            resolve: HTTP_ROUTE_RESOLVER,
        };
        super(path, _options);
        ConstructHTTPRoute(this, path, options);
    }
    get children() {
        return $super(this, Route).get('children');
    }
    get methods() {
        return HTTPRouteGetMethods(this);
    }
    resolve(options) {
        return super.resolve(options);
    }
}
//# sourceMappingURL=implementation.js.map